
export type SportsbookId =
  | 'prizepicks'
  | 'underdog'
  | 'sleeper'
  | 'fliff'
  | 'fanduel'
  | 'draftkings'
  | 'betmgm'
  | 'caesars'
  | 'circa'
  | 'fanatics'
  | 'hardrock'
  | 'betr'
  | 'novig'
  | 'prophetx'
  | 'dabble'
  | 'dkpick6'
  | 'parlayplay'
  | 'pinnacle'
  | 'kalshi'
  | 'polymarket'
  | 'rebet'
  | 'draftkingspredictions'
  | 'kambi'
  | 'betonline'
  | 'propbuilder'
  | 'bovada'
  | 'betrsportsbook'
  | 'shuffle'
  | 'sportzino'
  | 'sportsbettingag'
  | 'tailgate'
  | 'sleeperpredict'
  | 'courtside'
  | 'boomsports'
  | 'chalkboardpicks'
  | 'chalkboardssp'
  | 'smacktok'
  | 'fourcx'
  | 'fourcasters'
  | 'sxbet'
  | 'bet105'
  | 'onyxodds';

export interface SportsbookDescriptor {
  id: SportsbookId;
  display: string;
  logoCode: string;
  logoFilename?: string;
  columnKey?: string;
  defaultOdds?: number;
  priority?: number;
  colorHex: string;
  columnClass?: string;
}

const NON_ALNUM = /[^a-z0-9]/g;

export const SPORTSBOOKS: Record<SportsbookId, SportsbookDescriptor> = {
  prizepicks: {
    id: 'prizepicks',
    display: 'PrizePicks',
    logoCode: 'PP',
    columnKey: 'prizepicks_odds',
    defaultOdds: -119,
    priority: 13,
    colorHex: '#7e03f8',
  },
  underdog: {
    id: 'underdog',
    display: 'Underdog',
    logoCode: 'UD',
    columnKey: 'underdog_direct_odds',
    priority: 10,
    colorHex: '#fffb00',
  },
  sleeper: {
    id: 'sleeper',
    display: 'Sleeper',
    logoCode: 'SL',
    logoFilename: 'SLEEPER.png',
    columnKey: 'sleeper_direct_odds',
    priority: 14,
    colorHex: '#01d1dc',
  },
  fliff: {
    id: 'fliff',
    display: 'Fliff',
    logoCode: 'FL',
    columnKey: 'fliff_odds',
    priority: 9,
    colorHex: '#07a9c8',
  },
  fanduel: {
    id: 'fanduel',
    display: 'FanDuel',
    logoCode: 'FD',
    columnKey: 'fanduel_odds',
    priority: 1,
    colorHex: '#4491f7',
  },
  draftkings: {
    id: 'draftkings',
    display: 'DraftKings',
    logoCode: 'DK',
    columnKey: 'draftkings_odds',
    priority: 2,
    colorHex: '#6cb147',
  },
  betmgm: {
    id: 'betmgm',
    display: 'BetMGM',
    logoCode: 'MG',
    columnKey: 'betmgm_odds',
    priority: 5,
    colorHex: '#bea972',
  },
  pinnacle: {
    id: 'pinnacle',
    display: 'Pinnacle',
    logoCode: 'PN',
    logoFilename: 'PI.png',
    columnKey: 'pinnacle_odds',
    priority: 4,
    colorHex: '#fb5604',
  },
  caesars: {
    id: 'caesars',
    display: 'Caesars',
    logoCode: 'CS',
    columnKey: 'caesars_odds',
    priority: 3,
    colorHex: '#d6c39c',
  },
  circa: {
    id: 'circa',
    display: 'Circa',
    logoCode: 'CR',
    logoFilename: 'CI.png',
    columnKey: 'circa_odds',
    priority: 4,
    colorHex: '#ffffff',
  },
  fanatics: {
    id: 'fanatics',
    display: 'Fanatics',
    logoCode: 'FA',
    columnKey: 'fanatics_odds',
    priority: 12,
    colorHex: '#ffffff',
  },
  hardrock: {
    id: 'hardrock',
    display: 'Hard Rock',
    logoCode: 'HR',
    columnKey: 'hardrock_odds',
    priority: 7,
    colorHex: '#6c48f0',
  },
  betr: {
    id: 'betr',
    display: 'Betr',
    logoCode: 'BR',
    logoFilename: 'betr.png',
    columnKey: 'betr_odds',
    priority: 10,
    colorHex: '#dfa8ff',
  },
  novig: {
    id: 'novig',
    display: 'Novig',
    logoCode: 'NV',
    logoFilename: 'novig.png',
    columnKey: 'novig_odds',
    priority: 8,
    colorHex: '#ffffff',
  },
  prophetx: {
    id: 'prophetx',
    display: 'ProphetX',
    logoCode: 'PX',
    columnKey: 'prophetx_odds',
    priority: 7,
    colorHex: '#0ca249',
  },
  dabble: {
    id: 'dabble',
    display: 'Dabble',
    logoCode: 'DB',
    columnKey: 'dabble_odds',
    priority: 11,
    colorHex: '#6d3de8',
  },
  parlayplay: {
    id: 'parlayplay',
    display: 'ParlayPlay',
    logoCode: 'ParlayPlay',
    logoFilename: 'parlay_play.png',
    columnKey: 'parlayplay_odds',
    priority: 17,
    colorHex: '#ffcf10',
  },
  kalshi: {
    id: 'kalshi',
    display: 'Kalshi',
    logoCode: 'kalshi',
    columnKey: 'kalshi_odds',
    priority: 18,
    colorHex: '#00d296',
  },
  polymarket: {
    id: 'polymarket',
    display: 'Polymarket',
    logoCode: 'PM',
    columnKey: 'polymarket_odds',
    priority: 19,
    colorHex: '#2e5cff',
  },
  rebet: {
    id: 'rebet',
    display: 'Rebet',
    logoCode: 'RB',
    columnKey: 'rebet_odds',
    priority: 20,
    colorHex: '#fb6933',
  },
  draftkingspredictions: {
    id: 'draftkingspredictions',
    display: 'DK Predictions',
    logoCode: 'DKP',
    columnKey: 'draftkingspredictions_odds',
    priority: 24,
    colorHex: '#225843',
  },
  kambi: {
    id: 'kambi',
    display: 'Kambi',
    logoCode: 'KM',
    columnKey: 'kambi_odds',
    priority: 25,
    colorHex: '#feb91e',
  },
  betonline: {
    id: 'betonline',
    display: 'BetOnline',
    logoCode: 'BO',
    columnKey: 'betonline_odds',
    priority: 26,
    colorHex: '#f03337',
  },
  propbuilder: {
    id: 'propbuilder',
    display: 'PropBuilder',
    logoCode: 'PRB',
    logoFilename: 'propbuilder.jpeg',
    columnKey: 'propbuilder_odds',
    priority: 28,
    colorHex: '#19375d',
  },
  bovada: {
    id: 'bovada',
    display: 'Bovada',
    logoCode: 'BV',
    logoFilename: 'bovada.png',
    columnKey: 'bovada_odds',
    priority: 29,
    colorHex: '#c80203',
  },
  dkpick6: {
    id: 'dkpick6',
    display: 'DK Pick6',
    logoCode: 'DKP6',
    logoFilename: 'dkpick6.png',
    columnKey: 'dkpick6_odds',
    priority: 15,
    colorHex: '#ed6619',
  },
  betrsportsbook: {
    id: 'betrsportsbook',
    display: 'Betr Sportsbook',
    logoCode: 'BRS',
    logoFilename: 'betrsportsbook.png',
    columnKey: 'betrsportsbook_odds',
    priority: 30,
    colorHex: '#dfa8ff',
  },
  shuffle: {
    id: 'shuffle',
    display: 'Shuffle',
    logoCode: 'SH',
    logoFilename: 'shuffle.png',
    columnKey: 'shuffle_odds',
    priority: 33,
    colorHex: '#7717ff',
  },
  sportzino: {
    id: 'sportzino',
    display: 'Sportzino',
    logoCode: 'SZ',
    logoFilename: 'sportzino.png',
    columnKey: 'sportzino_odds',
    priority: 34,
    colorHex: '#ef330e',
  },
  sportsbettingag: {
    id: 'sportsbettingag',
    display: 'SportsBetting AG',
    logoCode: 'SBAG',
    logoFilename: 'sportsbettingag.png',
    columnKey: 'sportsbettingag_odds',
    priority: 35,
    colorHex: '#172945',
  },
  tailgate: {
    id: 'tailgate',
    display: 'Tailgate',
    logoCode: 'TG',
    logoFilename: 'tailgate.png',
    columnKey: 'tailgate_odds',
    priority: 39,
    colorHex: '#00b975',
  },
  sleeperpredict: {
    id: 'sleeperpredict',
    display: 'Sleeper Markets',
    logoCode: 'SLP',
    logoFilename: 'sleeperpredict.png',
    columnKey: 'sleeperpredict_odds',
    priority: 45,
    colorHex: '#03b8c4',
  },
  courtside: {
    id: 'courtside',
    display: 'Courtside',
    logoCode: 'CT',
    logoFilename: 'courtside.svg',
    columnKey: 'courtside_odds',
    priority: 46,
    colorHex: '#ff4a00',
  },
  boomsports: {
    id: 'boomsports',
    display: 'Boom',
    logoCode: 'BM',
    logoFilename: 'boom.png',
    columnKey: 'boomsports_odds',
    priority: 47,
    colorHex: '#64c1ed',
  },
  chalkboardpicks: {
    id: 'chalkboardpicks',
    display: 'Chalkboard Picks',
    logoCode: 'CB',
    logoFilename: 'chalkboard.png',
    columnKey: 'chalkboardpicks_odds',
    priority: 48,
    colorHex: '#ffffff',
  },
  chalkboardssp: {
    id: 'chalkboardssp',
    display: 'Chalkboard',
    logoCode: 'CBS',
    logoFilename: 'chalkboard.png',
    columnKey: 'chalkboardssp_odds',
    priority: 49,
    colorHex: '#ffffff',
  },
  smacktok: {
    id: 'smacktok',
    display: 'SmackTok',
    logoCode: 'SMK',
    logoFilename: 'smacktok.png',
    columnKey: 'smacktok_odds',
    priority: 50,
    colorHex: '#17f6a4',
  },
  fourcx: {
    id: 'fourcx',
    display: '4Cx',
    logoCode: '4CX',
    logoFilename: 'fourcx.png',
    columnKey: 'fourcx_odds',
    priority: 51,
    colorHex: '#272d58',
  },
  fourcasters: {
    id: 'fourcasters',
    display: '4casters',
    logoCode: '4C',
    logoFilename: 'fourcasters.png',
    columnKey: 'fourcasters_odds',
    priority: 52,
    colorHex: '#343B86',
  },
  sxbet: {
    id: 'sxbet',
    display: 'SX Bet',
    logoCode: 'SX',
    logoFilename: 'sxbet.png',
    columnKey: 'sxbet_odds',
    priority: 53,
    colorHex: '#40c0a0',
  },
  bet105: {
    id: 'bet105',
    display: 'Bet105',
    logoCode: 'B105',
    logoFilename: 'bet105.png',
    columnKey: 'bet105_odds',
    priority: 54,
    colorHex: '#3083dc',
  },
  onyxodds: {
    id: 'onyxodds',
    display: 'Onyx Odds',
    logoCode: 'ONYX',
    logoFilename: 'onyxodds.png',
    columnKey: 'onyxodds_odds',
    priority: 55,
    colorHex: '#8B5CF6',
  },
};

export const SPORTSBOOK_ALIASES: Record<string, SportsbookId> = {
  hardrockbet: 'hardrock',
  hardrock_sportsbook: 'hardrock',
  hardrocksportsbook: 'hardrock',
  'hardrock sportsbook': 'hardrock',
  'hard rock': 'hardrock',
  'hard rock bet': 'hardrock',
  dk: 'draftkings',
  'draft kings': 'draftkings',
  draftkings_sportsbook: 'draftkings',
  draftkingssportsbook: 'draftkings',
  'draft kings sportsbook': 'draftkings',
  fd: 'fanduel',
  fanduel_sportsbook: 'fanduel',
  fanduelsportsbook: 'fanduel',
  'fanduel sportsbook': 'fanduel',
  mgm: 'betmgm',
  'bet mgm': 'betmgm',
  betmgm_sportsbook: 'betmgm',
  betmgmsportsbook: 'betmgm',
  betrivers: 'kambi',
  'bet rivers': 'kambi',
  betrivers_sportsbook: 'kambi',
  betriverssportsbook: 'kambi',
  'betrivers sportsbook': 'kambi',
  caesars_sportsbook: 'caesars',
  'caesars sportsbook': 'caesars',
  caesarssportsbook: 'caesars',
  'prophet x': 'prophetx',
  prophetx_sportsbook: 'prophetx',
  prophetxsportsbook: 'prophetx',
  'prophet x sportsbook': 'prophetx',
  'parlay play': 'parlayplay',
  parlayplay_sportsbook: 'parlayplay',
  parlayplaysportsbook: 'parlayplay',
  'parlay play sportsbook': 'parlayplay',
  pick6: 'dkpick6',
  'pick 6': 'dkpick6',
  pick6_sportsbook: 'dkpick6',
  pick6sportsbook: 'dkpick6',
  'circa sportsbook': 'circa',
  'circasportsbook': 'circa',
  'circa_sportsbook': 'circa',
  'circa sports': 'circa',
  circa: 'circa',
  pinnacle_sportsbook: 'pinnacle',
  pinnaclesportsbook: 'pinnacle',
  'pinnacle sportsbook': 'pinnacle',
  pinnaclesports: 'pinnacle',
  pinny: 'pinnacle',
  polymarket_sportsbook: 'polymarket',
  polymarketsportsbook: 'polymarket',
  'polymarket sportsbook': 'polymarket',
  'poly market': 'polymarket',
  rebet_sportsbook: 'rebet',
  rebetsportsbook: 'rebet',
  'rebet sportsbook': 'rebet',
  'dk predictions': 'draftkingspredictions',
  'draftkings predictions': 'draftkingspredictions',
  dkpredictions: 'draftkingspredictions',
  kambi_sportsbook: 'kambi',
  kambisportsbook: 'kambi',
  'kambi sportsbook': 'kambi',
  betonlineag: 'betonline',
  betonline_ag: 'betonline',
  'betonline.ag': 'betonline',
  'bet online': 'betonline',
  'betonline sportsbook': 'betonline',
  'sleeper predict': 'sleeperpredict',
  'sleeper-predict': 'sleeperpredict',
  'sleeper markets': 'sleeperpredict',
  'sleeper team picks': 'sleeperpredict',
  'prop builder': 'propbuilder',
  'bovada.lv': 'bovada',
  bovadalv: 'bovada',
  'bovada sportsbook': 'bovada',
  'dk pick6': 'dkpick6',
  'draftkings pick6': 'dkpick6',
  'dk pik6': 'dkpick6',
  dkpik6: 'dkpick6',
  draftkingspick6: 'dkpick6',
  'betr sportsbook': 'betrsportsbook',
  'betr_sportsbook': 'betrsportsbook',
  'shuffle.com': 'shuffle',
  shufflecom: 'shuffle',
  'sportzino.com': 'sportzino',
  sportzinocom: 'sportzino',
  'sportsbetting.ag': 'sportsbettingag',
  'sports betting ag': 'sportsbettingag',
  'sportsbetting ag': 'sportsbettingag',
  'tail gate': 'tailgate',
  tailgate_sportsbook: 'tailgate',
  tailgatesportsbook: 'tailgate',
  'court side': 'courtside',
  'courtside app': 'courtside',
  courtsideapp: 'courtside',
  boom: 'boomsports',
  boomfantasy: 'boomsports',
  boom_fantasy: 'boomsports',
  'boom fantasy': 'boomsports',
  'boom sports': 'boomsports',
  boomsports_sportsbook: 'boomsports',
  chalkboard: 'chalkboardssp',
  'chalkboard picks': 'chalkboardpicks',
  chalkboard_picks: 'chalkboardpicks',
  chalkboardpicks_sportsbook: 'chalkboardpicks',
  'chalkboard ssp': 'chalkboardssp',
  chalkboard_ssp: 'chalkboardssp',
  chalkboardssp_sportsbook: 'chalkboardssp',
  'chalkboard sportsbook': 'chalkboardssp',
  '4cx': 'fourcx',
  '4casters': 'fourcasters',
  onyx: 'onyxodds',
};

export function normalizeSportsbookId(raw?: string | null): SportsbookId | '' {
  if (raw == null) {
    return '';
  }

  const normalized = raw.trim().toLowerCase();
  if (!normalized) {
    return '';
  }

  const directMatch = resolveCanonicalSportsbookId(normalized);
  if (directMatch) {
    return directMatch;
  }

  const cleaned = normalized.replace(NON_ALNUM, '');
  if (!cleaned) {
    return '';
  }

  return resolveCanonicalSportsbookId(cleaned);
}

export function sportsbookIdToDisplay(id?: string | null): string {
  const normalized = normalizeSportsbookId(id);
  if (normalized) {
    return SPORTSBOOKS[normalized].display;
  }
  return id ?? '';
}

function resolveCanonicalSportsbookId(candidate: string): SportsbookId | '' {
  if (Object.hasOwn(SPORTSBOOKS, candidate)) {
    return candidate as SportsbookId;
  }
  if (Object.hasOwn(SPORTSBOOK_ALIASES, candidate)) {
    return SPORTSBOOK_ALIASES[candidate];
  }
  return '';
}

export const ESPORTS_ACTIVE_BOOKS: SportsbookId[] = [
  'prizepicks',
  'underdog',
  'sleeper',
  'betr',
  'parlayplay',
  'dabble',
  'dkpick6',
  'boomsports',
  'chalkboardpicks',
  'smacktok',
];

export function getById(id: string): SportsbookDescriptor | undefined {
  const normalized = normalizeSportsbookId(id);
  return normalized ? SPORTSBOOKS[normalized] : undefined;
}

export function getLogoCode(id: string): string | undefined {
  return getById(id)?.logoCode;
}
